import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useAuthorisedOnly<T extends (...args: any) => any>(
  cb: T,
  currentReferralId: string
): (...args: Parameters<T>) => ReturnType<T> {
  const { authUser } = useAuthUser();
  return (...args) => {
    if (!authUser.value) {
      emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, { showLogin: true, currentReferralId });
      return;
    }
    // eslint-disable-next-line prefer-spread
    return cb.apply(undefined, args);
  };
}
